import { defineMessages } from "react-intl";

export default defineMessages({
    markups: {
        id: "components.viewer.markups",
        defaultMessage: "Markups",
    },
});
